// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"1e99926c","821":"a03b6271","940":"535f1fce"}[chunkId] + ".chunk.js";
};